export default __webpack_public_path__ + "static/media/logo.411238e3.svg";